import * as QUESTIONNAIRE_ITEM_TYPES from './questionnaire-item-types';

export const createQuestionAnswer = (questionnaireItem, answerValue) => {
  let answer = {};
  switch (questionnaireItem.questionnaireItemType) {
    case QUESTIONNAIRE_ITEM_TYPES.TEXT_QUESTION:
      answer = { ...answer,
        questionnaireItemId: questionnaireItem.questionnaireItemId,
        textAnswer: answerValue };
      break;
    case QUESTIONNAIRE_ITEM_TYPES.BOOLEAN_QUESTION:
    case QUESTIONNAIRE_ITEM_TYPES.RADIOBUTTON_QUESTION:
    case QUESTIONNAIRE_ITEM_TYPES.DROPDOWN_QUESTION:
      answer = { ...answer,
        questionnaireItemId: questionnaireItem.questionnaireItemId,
        listAnswerId: answerValue.listAnswerId,
        otherOptionText: answerValue.otherOptionText };
      break;
    case QUESTIONNAIRE_ITEM_TYPES.CHECKBOX_QUESTION:
      answer = { ...answer,
        questionnaireItemId: questionnaireItem.questionnaireItemId,
        listAnswerId: answerValue.listAnswerId,
        otherOptionText: answerValue.otherOptionText,
        isChecked: answerValue.isChecked };
      break;
    case QUESTIONNAIRE_ITEM_TYPES.NUMBER_QUESTION:
    case QUESTIONNAIRE_ITEM_TYPES.SLIDER_QUESTION:
      answer = { ...answer,
        questionnaireItemId: questionnaireItem.questionnaireItemId,
        numberAnswer: answerValue };
      break;
    case QUESTIONNAIRE_ITEM_TYPES.DATE_QUESTION:
      answer = { ...answer,
        questionnaireItemId: questionnaireItem.questionnaireItemId,
        dateAnswer: answerValue };
      break;
    case QUESTIONNAIRE_ITEM_TYPES.MATRIX_GROUPING:
      answer = { ...answer,
        questionnaireItemId: questionnaireItem.questionnaireItemId,
        listAnswerId: answerValue.listAnswerId };
      break;
    default:
      answer = { ...answer,
        questionnaireItemId: questionnaireItem.questionnaireItemId,
        textAnswer: answerValue };
  }

  return answer;
};